<template>
  <div class="summary-backgrounds" aria-hidden="true">
    <div class="summary-backgrounds__mobile">
      <div class="summary-backgrounds__top">
        <svg
          width="375"
          height="529"
          viewBox="0 0 375 529"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_41068_20157)">
            <g opacity="0.2" filter="url(#filter0_f_41068_20157)">
              <circle
                cx="188"
                cy="233"
                r="249"
                transform="rotate(-180 188 233)"
                fill="#FFC940"
              />
            </g>
            <g opacity="0.2" filter="url(#filter1_f_41068_20157)">
              <circle
                cx="188"
                cy="233"
                r="182"
                transform="rotate(-180 188 233)"
                fill="#FFC940"
              />
            </g>
            <g opacity="0.3" filter="url(#filter2_f_41068_20157)">
              <circle
                cx="188.6"
                cy="233.6"
                r="127.4"
                transform="rotate(-180 188.6 233.6)"
                fill="#FFC940"
              />
            </g>
            <circle
              opacity="0.3"
              cx="187.3"
              cy="232.3"
              r="63.7"
              transform="rotate(-180 187.3 232.3)"
              fill="#FFC940"
            />
          </g>
          <defs>
            <filter
              id="filter0_f_41068_20157"
              x="-261"
              y="-216"
              width="898"
              height="898"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="100"
                result="effect1_foregroundBlur_41068_20157"
              />
            </filter>
            <filter
              id="filter1_f_41068_20157"
              x="-24"
              y="21"
              width="424"
              height="424"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="15"
                result="effect1_foregroundBlur_41068_20157"
              />
            </filter>
            <filter
              id="filter2_f_41068_20157"
              x="51.2002"
              y="96.2002"
              width="274.8"
              height="274.8"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="5"
                result="effect1_foregroundBlur_41068_20157"
              />
            </filter>
            <clipPath id="clip0_41068_20157">
              <rect
                width="592"
                height="592"
                fill="white"
                transform="translate(484 529) rotate(-180)"
              />
            </clipPath>
          </defs>
        </svg>
      </div>
      <div class="summary-backgrounds__bottom">
        <svg
          width="375"
          height="592"
          viewBox="0 0 375 592"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_41068_20152)">
            <g opacity="0.2" filter="url(#filter0_f_41068_20152)">
              <circle
                cx="195"
                cy="296"
                r="249"
                transform="rotate(-180 195 296)"
                fill="#FFC940"
              />
            </g>
            <g opacity="0.2" filter="url(#filter1_f_41068_20152)">
              <circle
                cx="195"
                cy="296"
                r="182"
                transform="rotate(-180 195 296)"
                fill="#FFC940"
              />
            </g>
            <g opacity="0.3" filter="url(#filter2_f_41068_20152)">
              <circle
                cx="195.6"
                cy="296.6"
                r="127.4"
                transform="rotate(-180 195.6 296.6)"
                fill="#FFC940"
              />
            </g>
            <circle
              opacity="0.3"
              cx="194.3"
              cy="295.3"
              r="63.7"
              transform="rotate(-180 194.3 295.3)"
              fill="#FFC940"
            />
          </g>
          <defs>
            <filter
              id="filter0_f_41068_20152"
              x="-254"
              y="-153"
              width="898"
              height="898"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="100"
                result="effect1_foregroundBlur_41068_20152"
              />
            </filter>
            <filter
              id="filter1_f_41068_20152"
              x="-17"
              y="84"
              width="424"
              height="424"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="15"
                result="effect1_foregroundBlur_41068_20152"
              />
            </filter>
            <filter
              id="filter2_f_41068_20152"
              x="58.2002"
              y="159.2"
              width="274.8"
              height="274.8"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="5"
                result="effect1_foregroundBlur_41068_20152"
              />
            </filter>
            <clipPath id="clip0_41068_20152">
              <rect
                width="592"
                height="592"
                fill="white"
                transform="translate(491 592) rotate(-180)"
              />
            </clipPath>
          </defs>
        </svg>
      </div>
    </div>

    <div class="summary-backgrounds__desktop">
      <svg
        width="1136"
        height="284"
        viewBox="0 0 1136 284"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_f_40988_133187)">
          <g opacity="0.2" filter="url(#filter1_f_40988_133187)">
            <rect x="100" width="936" height="184" rx="92" fill="#FFC940" />
          </g>
          <g opacity="0.2" filter="url(#filter2_f_40988_133187)">
            <rect
              x="196"
              y="25"
              width="744"
              height="134"
              rx="67"
              fill="#FFC940"
            />
          </g>
          <g opacity="0.2" filter="url(#filter3_f_40988_133187)">
            <rect
              x="268"
              y="40"
              width="600"
              height="88"
              rx="44"
              fill="#FFC940"
            />
          </g>
          <rect x="340" y="55" width="456" height="42" rx="21" fill="#FFC940" />
          <g opacity="0.5" filter="url(#filter4_f_40988_133187)">
            <rect
              x="453.539"
              y="31.7271"
              width="228.923"
              height="39.2448"
              rx="19.6224"
              fill="white"
            />
          </g>
        </g>
        <defs>
          <filter
            id="filter0_f_40988_133187"
            x="0"
            y="-100"
            width="1136"
            height="384"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="50"
              result="effect1_foregroundBlur_40988_133187"
            />
          </filter>
          <filter
            id="filter1_f_40988_133187"
            x="50"
            y="-50"
            width="1036"
            height="284"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="25"
              result="effect1_foregroundBlur_40988_133187"
            />
          </filter>
          <filter
            id="filter2_f_40988_133187"
            x="186"
            y="15"
            width="764"
            height="154"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="5"
              result="effect1_foregroundBlur_40988_133187"
            />
          </filter>
          <filter
            id="filter3_f_40988_133187"
            x="263"
            y="35"
            width="610"
            height="98"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="2.5"
              result="effect1_foregroundBlur_40988_133187"
            />
          </filter>
          <filter
            id="filter4_f_40988_133187"
            x="441.539"
            y="19.7271"
            width="252.924"
            height="63.2446"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="6"
              result="effect1_foregroundBlur_40988_133187"
            />
          </filter>
        </defs>
      </svg>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.summary-backgrounds {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 100%;
  overflow: visible;
  pointer-events: none;

  &__mobile {
    position: absolute;
    inset: 0;

    @media (min-width: $w-medium-b) {
      display: none;
    }
  }

  &__top,
  &__bottom {
    position: absolute;
    left: 0;
    right: 0;
    width: 100%;
    line-height: 0;
  }

  &__top {
    top: 0;
  }

  &__bottom {
    bottom: 0;
  }

  &__top svg,
  &__bottom svg,
  &__desktop svg {
    display: block;
    width: 100%;
    height: auto;
  }

  &__desktop {
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    line-height: 0;

    @media (min-width: $w-medium-b) {
      display: block;
    }
  }
}
</style>
